export const StocktakeEndpoints = {
  GET_LOCATIONS: '/api/admin/stocktake/locations',
  GET_BIN: '/api/admin/stocktake/bin',
  SEARCH_PRODUCTS: '/api/admin/stocktake/product/search',
  REVIEW_SESSION: '/api/admin/stocktake/session/:ref/review',
  POST_SESSION: '/api/admin/stocktake/session/:ref/post',
  SESSION_DETAIL: '/api/admin/stocktake/session/:ref',
  MOVEMENT_CHECK: '/api/admin/stocktake/session/:ref/movement-check',
  APPROVE_SESSION: '/api/admin/stocktake/session/:ref/approve',
  REJECT_SESSION: '/api/admin/stocktake/session/:ref/reject',
  GET_SESSIONS: '/api/admin/stocktake/sessions',
  CAPABILITIES: '/api/admin/stocktake/capabilities',
};
